import { Ticket } from "./Ticket"

export type Notification = {
  Ticket: Ticket
  ticket: Ticket
  TicketId: number
  updatedAt: string
  title: string
}

export type SatisfactionSurvey = Record<string, unknown>

// TODO CONFERIR NO DB DEPOIS
export enum StatusUserEnum {
  "Em aberto" = 1,
  "Aguardando Cliente" = 2,
  "Em atendimento" = 3,
  "Concluido" = 4,
}

export enum Weekdays {
  sunday = 0,
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6,
}

export type TMenu = {
  type: string
  description: string
  link: string
  MenuId: number
}
